/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Google_Drive_Action_ErrorInputs */

const en_google_drive_action_error = /** @type {(inputs: Google_Drive_Action_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not complete the Google Drive request. Please try again.`)
};

const es_google_drive_action_error = /** @type {(inputs: Google_Drive_Action_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo completar la solicitud a Google Drive. Inténtalo de nuevo.`)
};

/**
* | output |
* | --- |
* | "Could not complete the Google Drive request. Please try again." |
*
* @param {Google_Drive_Action_ErrorInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const google_drive_action_error = /** @type {((inputs?: Google_Drive_Action_ErrorInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Google_Drive_Action_ErrorInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_google_drive_action_error(inputs)
	return en_google_drive_action_error(inputs)
});